import { Body, H4, Stack, useWindowProperties } from '@qred/components-library';
import { currencyFormatter } from '@qred/fe-cp-formatting-helpers';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { LabelValueGrid } from '~/components/shared/Layout/LabelValueGrid';
import SpinnerCircular from '~/components/shared/Spinner/SpinnerCircular';
import constVars from '~/constants/constVars';
import useTranslate from '~/hooks/useTranslate';
import { fetchAdditionalSignerCardApplication } from '~/store/actions/additionalSignerActions';
import { ApiStatus, RootState } from '~/store/types/sharedTypes';
import { CardAdditionalSignerFooter } from './CardAdditionalSignerFooter';

export const CardAdditionalSigner = () => {
  const dispatch = useDispatch();

  const {
    intl: { market },
    additionalSigner: { additionalSignerCardApplicationOffer, apiStatus },
  } = useSelector((state: RootState) => state);

  const translate = useTranslate();
  const history = useHistory();

  const { isMobile } = useWindowProperties();

  const formatter = currencyFormatter(market);

  useEffect(() => {
    dispatch(fetchAdditionalSignerCardApplication(market));
  }, []);

  useEffect(() => {
    if (apiStatus.fetchAdditionalSignerCardApplication === ApiStatus.Failed) {
      history.push(constVars.ROUTE_SIGNER_ERROR);
    }
  }, [apiStatus.fetchAdditionalSignerCardApplication]);

  const cardDetailsLabelAndValue1 = [
    {
      label: translate('CreditCardDetailsCard.CompanyName') as string,
      value: additionalSignerCardApplicationOffer.companyName,
    },
    {
      label: translate('CreditCardDetailsCard.ApprovedCredit') as string,
      value: formatter.format(
        additionalSignerCardApplicationOffer.offeredCreditLimit
      ),
    },
  ];

  const cardDetailsLabelAndValue2 = [
    {
      label: translate('CreditCardDetailsCard.YearlyMonthlyFee') as string,
      value: formatter.format(0),
    },
    {
      label: translate(
        'CreditCardDetailsCard.InterestFreePeriodLabel'
      ) as string,
      value: translate(
        'CreditCardDetailsCard.InterestFreePeriodValue'
      ) as string,
    },
  ];

  return additionalSignerCardApplicationOffer.cardApplicationUuid ? (
    <>
      <Stack p={'xxl'} spacing={'xxl'}>
        <Stack>
          <H4>{translate('OnboardingCardOffer.ConfirmOfferTitle')}</H4>
          <Body size="lg">
            {translate('OnboardingCardOffer.ConfirmOfferDescription')}
          </Body>
        </Stack>
        <Stack spacing={'xxl'}>
          <LabelValueGrid
            items={cardDetailsLabelAndValue1}
            isMobile={isMobile}
            gridTemplateColumns="auto"
          />
          <LabelValueGrid
            items={cardDetailsLabelAndValue2}
            isMobile={isMobile}
            gridTemplateColumns="auto"
          />
        </Stack>
        <Body size="lg" mt={50} align="center">
          {translate('CreditCardDetailsCard.CashbackInfo')}
        </Body>
      </Stack>
      <CardAdditionalSignerFooter />
    </>
  ) : (
    <SpinnerCircular />
  );
};
